// Recovered compiled webpack factory 3789. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      isRecoverableError: function () {
        return l;
      },
      onRecoverableError: function () {
        return u;
      },
    }));
  let n = r(28140),
    a = r(24553),
    o = n._(r(42444)),
    i = r(3463),
    s = new WeakSet();
  function l(e) {
    return s.has(e);
  }
  let u = (e) => {
    let t = (0, o.default)(e) && "cause" in e ? e.cause : e;
    (0, a.isBailoutToCSRError)(t) || (0, i.reportGlobalError)(t);
  };
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
